import { AuctionInsightKey } from '~/src/dash/apiV2/auctionInsights';
import { ISankeyNodeConfig } from '~/src/dash/components/charts/Sankey/common';
import { graphColors } from '~/src/dash/utils/colors';

export const dealAuctionInsightsNodes: Partial<Record<AuctionInsightKey, ISankeyNodeConfig>> = {
  TotalBidRequested: {
    tKey: 'BidRequests',
    color: graphColors.lightblue,
    order: 1,
    depth: 0, // Start
  },
  TotalBidResponse: {
    tKey: 'BidResponses',
    color: graphColors.turquoise,
    order: 2,
    depth: 1,
  },
  TotalInvalidCreatives: {
    tKey: 'InvalidCreatives',
    color: graphColors.blueGrey,
    order: 3,
    depth: 1,
    isTerminal: true,
  },
  TotalNoBid: {
    tKey: 'NoBids',
    color: graphColors.paleYellow,
    order: 4,
    depth: 1,
    isTerminal: true,
  },
  TotalBidTimeout: {
    tKey: 'BidTimeouts',
    color: graphColors.slateGrey,
    order: 5,
    depth: 1,
    isTerminal: true,
  },
  TotalConnectionErrors: {
    tKey: 'ConnectionErrors',
    color: graphColors.redOrange,
    order: 6,
    depth: 1,
    isTerminal: true,
  },
  TotalInvalidBids: {
    tKey: 'InvalidBids',
    color: graphColors.sienna,
    order: 7,
    depth: 1,
    isTerminal: true,
  },
  TotalValidBids: {
    tKey: 'ValidBids',
    color: graphColors.pink,
    order: 8,
    depth: 2,
  },
  TotalBidResponseErrors: {
    tKey: 'BidResponseErrors',
    color: graphColors.palePink,
    order: 9,
    depth: 2,
    isTerminal: true,
  },
  TotalUnwrapErrors: {
    tKey: 'UnwrapErrors',
    color: graphColors.purpleBlue,
    order: 10,
    depth: 2,
    isTerminal: true,
  },
  TotalBidWon: {
    tKey: 'BidWon',
    color: graphColors.seaGreen,
    order: 11,
    depth: 3,
  },
  TotalBidLost: {
    tKey: 'BidLost',
    color: graphColors.coralPink,
    order: 12,
    depth: 3,
    isTerminal: true,
  },
  TotalValidBidsRejected: {
    tKey: 'BidRejected',
    color: graphColors.limeGreen,
    order: 13,
    depth: 3,
    isTerminal: true,
  },
  TotalBidderImpression: {
    tKey: 'Impressions',
    color: graphColors.lightOrange,
    order: 14,
    depth: 4,
    isTerminal: true,
  },
  TotalBidderNoImpression: {
    tKey: 'NoImpressions',
    color: graphColors.fluorescentPink,
    order: 15,
    depth: 4,
    isTerminal: true,
  },
};
